import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Button,
  Badge,
  Collapse,
  ButtonToolbar
} from 'react-bootstrap';
import './styles.scss';
import MyMeetingsStore from '../my_meetings_components/stores/MyMeetingsStore';
import { MEETINGS_STATE } from '../igmeetings_components/constants';
import MeetingDate from '../igmeetings_components/MeetingDate';
import MeetingPlace from '../igmeetings_components/MeetingPlace';

@injectIntl
@observer
export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      show: -1,
      selectedMeeting: undefined
    };
  }

  target = [];

  renderIncomingMeetings = incoming =>
    incoming.map((meeting, id) => (
      <a key={id} className="meeting-link" href={`/my_meetings/${meeting.id}`}>
        {this.renderMeetingInfo(meeting)}
      </a>
    ));

  handleAccept = meeting => {
    MyMeetingsStore.confirmMeetingInvitation(meeting);
    this.setState({ selectedMeeting: undefined, show: -1 });
  };

  handleDecline = meeting => {
    MyMeetingsStore.declineMeetingInvitation(meeting);
    this.setState({ selectedMeeting: undefined, show: -1 });
  };

  renderMeetingInfo = meeting => (
    <div className="meeting-info-container">
      <Row>
        <Col md={10}>
          <div>
            <div className="media-title">
              <h4>
                <Badge>{meeting.owner_name}</Badge>&nbsp;
                {meeting.subject}
              </h4>
            </div>
          </div>
          <MeetingDate meeting={meeting} />
          <div>
            <MeetingPlace meeting={meeting} />
          </div>
        </Col>
      </Row>

      <Col md={2}></Col>
    </div>
  );

  getTarget = id => ReactDOM.findDOMNode(this.target[id]);

  renderUnconfirmedMeetings = unconfirmed => {
    const { intl } = this.props;

    // console.log(this.state.show);

    return (
      <div style={{ width: '95%' }}>
        <h4 style={{ fontWeight: 'bolder' }}>
          {intl.formatMessage({ id: 'unconfirmed_meetings' })}
        </h4>
        {unconfirmed.map((meeting, id) => (
          <div key={id}>
            <div
              style={{ cursor: 'pointer', backgroundColor: '#e5f1f9' }}
              onClick={() =>
                this.setState({
                  show: this.state.show != id ? id : -1,
                  selectedMeeting: meeting,
                  overlayTarget: this.getTarget(id)
                })
              }
            >
              {this.renderMeetingInfo(meeting)}
            </div>

            <Collapse in={this.state.show == id}>
              <div>
                <div>
                  <ButtonToolbar style={{ margin: 0 }}>
                    <Button
                      bsStyle="primary"
                      style={{ margin: 0 }}
                      onClick={() => this.handleAccept(meeting)}
                      block
                    >
                      {this.props.intl.formatMessage({ id: 'confirm' })}
                    </Button>

                    <Button
                      bsStyle="danger"
                      style={{ marginLeft: 0, marginBottom: 10 }}
                      onClick={() => this.handleAccept(meeting)}
                      block
                    >
                      {this.props.intl.formatMessage({ id: 'decline' })}
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            </Collapse>
          </div>
        ))}
        <hr />
      </div>
    );
  };

  renderNoMeetingMessage = () => {
    return (
      <React.Fragment>
        <div className="form-container">
          <div className="meeting-icon">
            <i className="fa fa-calendar-check-o" />
            <h1 style={{ position: 'relative' }}>
              {this.props.intl.formatMessage({ id: 'no_meetings_list' })}
            </h1>
          </div>
          {this.renderMeetingsLinks()}
        </div>
      </React.Fragment>
    );
  };

  renderMeetingsLinks = () => (
    <Row className="meeting-links">
      <Col md={6} xs={6}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`/${this.props.intl.locale}/memberships/meetings/new`}
        >
          {this.props.intl.formatMessage({ id: 'create' })}
        </a>
      </Col>
      <Col md={6} xs={6}>
        <a target="_blank" rel="noopener noreferrer" href="/my_meetings/">
          {this.props.intl.formatMessage({ id: 'all' })}
        </a>
      </Col>
    </Row>
  );

  renderMeetingsContainer = () => {
    const { intl } = this.props;

    const pred = (a, b) =>
      new Date(a.start_date).getTime() - new Date(b.start_date).getTime();

    const pending = MyMeetingsStore.getMeetingsByState(
      MEETINGS_STATE.PENDING
    ).sort(pred);

    const incoming = MyMeetingsStore.getMeetingsByState(
      MEETINGS_STATE.CONFIRMED
    )
      .filter(
        meeting =>
          new Date(meeting.finish_date).getTime() - new Date().getTime() > 0
      )
      .sort(pred);

    if (pending.length == 0 && incoming.length == 0) {
      return this.renderNoMeetingMessage();
    }

    return (
      <div className="form-container">
        <div className="meetings-scroll">
          {pending.length > 0 && this.renderUnconfirmedMeetings(pending)}
          <h4 style={{ fontWeight: 'bolder' }}>
            {intl.formatMessage({ id: 'incoming_meetings' })}
          </h4>
          {this.renderIncomingMeetings(incoming)}
        </div>

        {this.renderMeetingsLinks()}
      </div>
    );
  };

  componentDidMount() {
    MyMeetingsStore.setCurrentUser(this.props.currentUser);
  }

  componentDidUpdate(nextProps, prevState) {
    if (prevState.open != this.state.open && !prevState.open) {
      MyMeetingsStore.loadMoreMeetingsByState(MEETINGS_STATE.CONFIRMED, 1);
      MyMeetingsStore.loadMoreMeetingsByState(MEETINGS_STATE.PENDING, 1);
    }
  }

  render() {
    const { intl } = this.props;
    let formElement = this.renderMeetingsContainer();
    let counter = MyMeetingsStore.getMeetingsByState(MEETINGS_STATE.PENDING)
      .length;
    const incomingCounter = MyMeetingsStore.getMeetingsByState(
      MEETINGS_STATE.CONFIRMED
    ).filter(
      meeting =>
        new Date(meeting.finish_date).getTime() - new Date().getTime() > 0
    ).length;

    const displayIncomingCounter = counter == 0 && incomingCounter > 0;

    const display = counter > 0 ? {} : { display: 'none' };
    return (
      <div className={'meetings-launcher'}>
        {this.state.open && formElement}
        <button
          type="button"
          className={'launcher ' + (this.state.open ? 'open' : '')}
          onClick={this.toggleOpen}
          title={intl.formatMessage({ id: 'igmeetings_help' })}
        >
          <i
            className={
              'fa ' +
              (this.state.open
                ? 'fa-remove open-launcher'
                : 'fa-phone close-launcher')
            }
          />
          {!this.state.open && (
            <span
              id="meetings-count-badge"
              className="badge navbar-count-badge"
              style={display}
            >
              {counter}
            </span>
          )}

          {displayIncomingCounter && (
            <span
              id="incoming-count-badge"
              className="badge navbar-count-badge"
            >
              <i className="fa fa-clock-o" />
            </span>
          )}
        </button>
      </div>
    );
  }

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  };
}
